<template>
  <section>
    <div class="mb-2">
      <FormFieldsRow
        v-for="(requisiteRule,index) in value"
        :key="index"
        :index="index"
        :isEditing="isEditing === index"
        class="mb-1"
        @cancel="isEditing=null"
      >
        <div
          class="px-2 py-3"
          @click.stop="isEditing = index"
        >
          <AdvanceRequisiteRule
            :value="requisiteRule"
            @input="updateRequisiteRule(index, $event)"
          />
          <AppButton
            v-if="isEditing === index"
            variant="danger"
            class="mt-1"
            @click="deleteRequisiteRule(index)"
          >
            <AppIcon name="delete" />
          </AppButton>
        </div>
      </FormFieldsRow>
    </div>
    <AppButton
      :raised="true"
      @click="addRequisiteRule"
    >
      <AppIcon name="add" />
      <slot>Rule</slot>
    </AppButton>
  </section>
</template>

<script>
import AdvanceRequisiteRule from './AdvanceRequisiteRule'
import FormFieldsRow from '@/components/Forms/FormFieldsRow'

export default {
  components: {
    AdvanceRequisiteRule,
    FormFieldsRow,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return { isEditing: null }
  },
  methods: {
    addRequisiteRule () {
      this.update([ ...this.value, {} ])
    },
    deleteRequisiteRule (index) {
      this.update(this.value.filter((v, i) => index !== i))
    },
    updateRequisiteRule (index, item) {
      const [ head, tail ] = [ this.value.slice(0, index), this.value.slice(index + 1) ]
      this.update([ ...head, item, ...tail ])
    },
    update (value) {
      this.$emit('input', value)
    },
  },
}
</script>
